export default [
  {
    name: 'Versichererabrechnung',
    path: '/versichererabrechnung',
    component: () => import('@/views/Versichererabrechnung/Versichererabrechnung.vue')
  }
]
